import { Route, Routes } from "react-router-dom";

import CarreraRecursosNaturales from "../newPages/carrerasnew/CarreraRecursosNaturales";
import CarreraRiesgos from "../newPages/carrerasnew/CarreraRiesgos";
import CarreraEnergia from "../newPages/carrerasnew/CarreraEnergia";
import CarreraNegociosInternacionales from "../newPages/carrerasnew/CarreraNegociosInternacionales";
import CarreraGovTech from "../newPages/carrerasnew/CarreraGovTech";
import CarreraNegociosTuristicos from "../newPages/carrerasnew/CarreraNegociosTuristicos";
import CarreraRedes from "../newPages/carrerasnew/CarreraRedes";
import CarreraAdministracionEmpresas from "../newPages/carrerasnew/CarreraAdministracionEmpresas";
import CarreraGastronomia from "../newPages/carrerasnew/CarreraGastronomia";
import CarreraAgronegocios from "../newPages/carrerasnew/CarreraAgronegocios";
import CarreraCienciasPoliticas from "../newPages/carrerasnew/CarreraCienciasPoliticas";
import CarreraComunicacion from "../newPages/carrerasnew/CarreraComunicacion";
import CarreraContabilidad from "../newPages/carrerasnew/CarreraContabilidad";
import CarreraDerecho from "../newPages/carrerasnew/CarreraDerecho";
import CarreraEconomia from "../newPages/carrerasnew/CarreraEconomia";
import CarreraEducacionBasica from "../newPages/carrerasnew/CarreraEducacionBasica";
import CarreraEducacionInicial from "../newPages/carrerasnew/CarreraEducacionInicial";
import CarreraFinanzas from "../newPages/carrerasnew/CarreraFinanzas";
import CarreraGestionAmbiental from "../newPages/carrerasnew/CarreraGestionAmbiental";
import CarreraLogisticaTransporte from "../newPages/carrerasnew/CarreraLogisticaTransporte";
import CarreraPedagogiaLenguaLiteratura from "../newPages/carrerasnew/CarrerasPegagogiaLenguaLiteratura";
import CarreraPedagogiaQuimicaBiologia from "../newPages/carrerasnew/CarrerasPegagogiaQuimicaBiologia";
import CarreraPedagogiaMatematicaFisica from "../newPages/carrerasnew/CarrerasPegagogiaMatematicaFisica";
import CarreraPedagogiaIdiomas from "../newPages/carrerasnew/CarreraPedagogiaIdiomas";
import CarreraPedagogiaCienciasSociales from "../newPages/carrerasnew/CarreraPedagogiaCienciasSociales";
import CarreraPsicologia from "../newPages/carrerasnew/CarreraPsicologia";
import CarreraPsicopedagogia from "../newPages/carrerasnew/CarreraPsicopedagogia";
import CarreraSeguridad from "../newPages/carrerasnew/CarreraSeguridad";
import CarreraTecnologiasInformacion from "../newPages/carrerasnew/CarreraTecnologiasInformacion";
import CarreraTurismo from "../newPages/carrerasnew/CarreraTurismo";
import CarreraAgropecuaria from "../newPages/carrerasnew/CarreraAgropecuaria";
import CarreraAlimentos from "../newPages/carrerasnew/CarreraAlimentos";
import CarreraArtesEscenicas from "../newPages/carrerasnew/CarreraArtesEscenicas";
import CarreraArtesVisuales from "../newPages/carrerasnew/CarreraArtesVisuales";
import CarreraBiologia from "../newPages/carrerasnew/CarreraBiologia";
import CarreraGeologia from "../newPages/carrerasnew/CarreraGeologia";
import CarreraIngenieriaAmbiental from "../newPages/carrerasnew/CarreraIngenieriaAmbiental";
import CarreraTelecomunicaciones from "../newPages/carrerasnew/CarreraTelecomunicaciones";
import CarreraArquitectura from "../newPages/carrerasnew/CarreraArquitectura";
import CarreraBioquimicaFarmacia from "../newPages/carrerasnew/CarreraBioquimicaFarmacia";
import CarreraComputacion from "../newPages/carrerasnew/CarreraComputacion";

function RoutesCarreras() {
  return (
    <>
      <Routes>
        <Route
          path="/carrera-recursos-naturales"
          element={<CarreraRecursosNaturales></CarreraRecursosNaturales>}
        />

        <Route path="/carrera-riesgos-online" element={<CarreraRiesgos />} />

        <Route path="/carrera-energia-online" element={<CarreraEnergia />} />

        <Route
          path="/carrera-negocios-internacionales"
          element={<CarreraNegociosInternacionales />}
        />

        <Route
          path="/carrera-govtech-online"
          element={<CarreraGovTech></CarreraGovTech>}
        />

        <Route
          path="/carrera-negocios-turisticos"
          element={<CarreraNegociosTuristicos />}
        />

        <Route
          path="/carrera-administracion-empresas"
          element={<CarreraAdministracionEmpresas />}
        />

        <Route path="/carrera-gastronomia" element={<CarreraGastronomia />} />
        <Route path="/carrera-redes" element={<CarreraRedes />} />
        <Route path="/carrera-agronegocios" element={<CarreraAgronegocios />} />
        <Route
          path="/carrera-ciencias-politicas"
          element={<CarreraCienciasPoliticas />}
        />
        <Route path="/carrera-comunicacion" element={<CarreraComunicacion />} />
        <Route
          path="/carrera-contabilidad-auditoria"
          element={<CarreraContabilidad />}
        />
        <Route path="/carrera-derecho" element={<CarreraDerecho />} />
        <Route path="/carrera-economia" element={<CarreraEconomia />} />
        <Route
          path="/carrera-educacion-basica"
          element={<CarreraEducacionBasica />}
        />
        <Route
          path="/carrera-educacion-inicial"
          element={<CarreraEducacionInicial />}
        />
        <Route path="/carrera-finanzas" element={<CarreraFinanzas />} />

        <Route
          path="/carrera-gestion-ambiental"
          element={<CarreraGestionAmbiental />}
        />

        <Route
          path="/carrera-logistica-transporte"
          element={<CarreraLogisticaTransporte />}
        />

        <Route
          path="/carrera-pedagogia-lengua-literatura"
          element={<CarreraPedagogiaLenguaLiteratura />}
        />
        <Route
          path="/carrera-pedagogia-quimica-biologia"
          element={<CarreraPedagogiaQuimicaBiologia />}
        />

        <Route
          path="/carrera-pedagogia-matematica-fisica"
          element={<CarreraPedagogiaMatematicaFisica />}
        />

        <Route
          path="/carrera-pedagogia-idiomas"
          element={<CarreraPedagogiaIdiomas />}
        />

        <Route
          path="/carrera-pedagogia-ciencias-sociales"
          element={<CarreraPedagogiaCienciasSociales />}
        />

        <Route path="/carrera-psicologia" element={<CarreraPsicologia />} />
        <Route
          path="/carrera-psicopedagogia"
          element={<CarreraPsicopedagogia />}
        />
        <Route path="/carrera-seguridad" element={<CarreraSeguridad />} />
        <Route
          path="/carrera-tecnologias-informacion"
          element={<CarreraTecnologiasInformacion />}
        />
        <Route path="/carrera-turismo" element={<CarreraTurismo />} />

        <Route path="/carrera-agropecuaria" element={<CarreraAgropecuaria />} />
        <Route path="/carrera-alimentos" element={<CarreraAlimentos />} />

        <Route
          path="/carrera-artes-escenicas"
          element={<CarreraArtesEscenicas />}
        />

        <Route
          path="/carrera-artes-visuales"
          element={<CarreraArtesVisuales />}
        />
        <Route path="/carrera-biologia" element={<CarreraBiologia />} />

        <Route path="/carrera-geologia" element={<CarreraGeologia />} />
        <Route
          path="/carrera-ingenieria-ambiental"
          element={<CarreraIngenieriaAmbiental />}
        />

          <Route
          path="/carrera-telecomunicaciones"
          element={<CarreraTelecomunicaciones />}
        />
           <Route
          path="/carrera-arquitectura"
          element={<CarreraArquitectura />}
        />

              <Route
          path="/carrera-bioquimica-farmacia"
          element={<CarreraBioquimicaFarmacia />}
        />
        
          <Route
          path="/carrera-computacion"
          element={<CarreraComputacion/>}
        />
      </Routes>{" "}
    </>
  );
}

export default RoutesCarreras;
